import React from 'react';

// Styles
import './WpDropdownMenuTitle.scss';

type Props = {
  title: string;
};

const WpDropdownMenuTitle = ({ title }: Props) => {
  return <li className="WpDropdownMenuTitle">{title}</li>;
};

export default WpDropdownMenuTitle;
